import React from "react";

function RightArrow(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M20.707 5.293a1 1 0 010 1.414L11.414 16l9.293 9.293a1 1 0 01-1.414 1.414l-10-10a1 1 0 010-1.414l10-10a1 1 0 011.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default RightArrow;